import React from 'react';
import {
  Container,
  Typography,
  Button,
  Box,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Card,
  CardContent,
} from '@mui/material';
import { motion } from 'framer-motion';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const coverageAreas = [
  {
    title: 'Embu Town',
    description: 'Central Business District and surrounding areas',
    locations: [
      'Dallas Area',
      'Blue Valley',
      'Stadium Area',
      'Market Area',
      'Town Center'
    ]
  },
  {
    title: 'Residential Areas',
    description: 'Major residential estates in Embu',
    locations: [
      'Majengo Estate',
      'Bonanza',
      'Green Valley',
      'Mjini Area',
      'Dallas Estate'
    ]
  },
  {
    title: 'Business Districts',
    description: 'Commercial and business zones',
    locations: [
      'Industrial Area',
      'Kamiu Road',
      'Nthambo Area',
      'Kangaru Area',
      'Commercial Center'
    ]
  }
];

const Coverage = () => {
  return (
    <Container sx={{ py: 8 }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Typography variant="h3" component="h1" gutterBottom align="center" sx={{ color: 'white' }}>
          Service Coverage Areas
        </Typography>
        <Typography variant="h6" gutterBottom align="center" sx={{ color: 'rgba(255, 255, 255, 0.9)', mb: 6 }}>
          We provide high-speed internet service throughout Embu County
        </Typography>

        <Grid container spacing={4}>
          {coverageAreas.map((area, index) => (
            <Grid item xs={12} md={4} key={area.title}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
              >
                <Card sx={{
                  height: '100%',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  backdropFilter: 'blur(10px)',
                  color: 'white',
                  transition: 'transform 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-10px)',
                  },
                }}>
                  <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <CheckCircleIcon sx={{ color: '#4caf50', mr: 1 }} />
                      <Typography variant="h6">{area.title}</Typography>
                    </Box>
                    <Typography variant="body2" sx={{ mb: 2, color: 'rgba(255, 255, 255, 0.7)' }}>
                      {area.description}
                    </Typography>
                    <List dense>
                      {area.locations.map((location) => (
                        <ListItem key={location}>
                          <ListItemIcon>
                            <LocationOnIcon sx={{ color: '#2196f3' }} />
                          </ListItemIcon>
                          <ListItemText 
                            primary={location}
                            sx={{ '& .MuiListItemText-primary': { color: 'white' } }}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>

        <Box
          sx={{
            mt: 6,
            p: 4,
            textAlign: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(10px)',
            borderRadius: 2,
          }}
        >
          <Typography variant="h5" gutterBottom sx={{ color: 'white' }}>
            Want to check if we cover your specific location?
          </Typography>
          <Button
            variant="contained"
            color="primary"
            size="large"
            startIcon={<PhoneIcon />}
            href="tel:+254715517079"
            sx={{
              mt: 2,
              py: 1.5,
              px: 4,
              fontSize: '1.1rem',
              background: 'linear-gradient(45deg, #2196f3 30%, #00e5ff 90%)',
              '&:hover': {
                background: 'linear-gradient(45deg, #1976d2 30%, #00b8d4 90%)',
              },
            }}
          >
            Call Us: 0715 517 079
          </Button>
        </Box>
      </motion.div>
    </Container>
  );
};

export default Coverage;
